<template>
    <!-- Detalhes da campanha -->
    <mu-paper class="item" v-bind:class="{ 'schedule': isSchedule, 'deleted': isDeleted }" :z-depth="2" v-if="item">
        <!-- Data e titulo da campanha -->
        <mu-row justify-content="start" align-items="center">
            <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                <div class="content-box">
                    <div>
                        <span class="origin" v-bind:class="{ 'app': item.origin === 'app' || item.origin === 'app#', 'api': item.origin === 'single' || item.origin === 'v2' || item.origin === 'v1' }">{{ item.origin === 'v1' || item.origin === 'v2' || item.origin === 'single' ? 'API' : 'WEB ' + item.origin.replace('app', '') }}</span>
                        <span class="origin type" v-if="item.services.type === 'voice'">Mensagem de Voz</span>
                    </div>
                    <h3>
                        <router-link :to="{ name: 'app.services.sms.details', params: { id: item.id } }" v-if="!isDeleted">
                            {{ item.title }}
                        </router-link>
                        <div v-else>
                            {{ item.title }}
                        </div>
                    </h3>
                    <mu-flex justify-content="start" align-items="center" class="date">
                        <font-awesome-icon icon="calendar-alt"  v-if="!isSchedule && !isDeleted"/>
                        <font-awesome-icon icon="stopwatch"  v-if="isSchedule && !isDeleted"/>
                        <font-awesome-icon icon="ban"  v-if="isDeleted"/>
                        <span>{{ textDate() }}</span>
                    </mu-flex>
                </div>
            </mu-col>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <mu-flex justify-content="end" align-items="center" class="group-buttons" v-if="item.deleted_at == null">
                    <mu-button class="btn-custom" round color="#ccc" textColor="#666" @click="isVisible()">
                        <font-awesome-icon icon="list-ol" class="icon-md icon-margin-left hidden-mobile"/>
                        Estatísticas
                    </mu-button>
                    <mu-button class="btn-custom" round color="secondary" :to="{ name: 'app.services.sms.details', params: { id: item.id } }">
                        <font-awesome-icon icon="eye" class="icon-md icon-margin-left"/>
                        Ver Campanha
                    </mu-button>
                </mu-flex>
            </mu-col>
        </mu-row>

        <!-- Estatísticas -->
        <div v-if="statistics.visible" class="block-statistics">
            <mu-campaign-statistics :id="item.id"></mu-campaign-statistics>
        </div>

    </mu-paper>
</template>

<script>
    import moment from 'moment'
    import momentTimezone from 'moment-timezone'

    export default {
        name: 'card-campaign',
        props: ['item'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                statistics: {
                    visible: false
                },
                isSchedule: false,
                isDeleted: false
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Responsavel por deixar visivel ou invisivel as estatisticas
             */
            isVisible () {
                this.statistics.visible = !this.statistics.visible
            },

            /**
             * Mostra que tipo de texto para a data, se é agendado ou não
             */
            textDate () {
                if (this.item.deleted_at !== null) {
                    this.isDeleted = true
                    return `Campanha cancelada em ${moment(this.item.deleted_at).format('DD/MM/YYYY HH:mm')}`
                }
                if (this.item.sented_at === null && this.item.scheluded_to === null) {
                    return ''
                }
                if (this.wasSent()) {
                    if (this.item.sented_at) {
                        return `Enviado em ${momentTimezone.utc(this.item.sented_at).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')}`
                    }
                    return ''
                }
                this.isSchedule = true
                return `Agendado para ${moment(this.item.scheluded_to || this.item.sented_at).format('DD/MM/YYYY HH:mm')}`
            },

            /**
             * Validação se a campanha já foi enviada ou não
             * Se já foi enviada retorna TRUE
             */
            wasSent () {
                let schedule
                let now = moment().format('YYYY-MM-DD HH:mm')
                let sented = momentTimezone.utc(this.item.sented_at).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm')

                if (this.item.scheluded_to) {
                    schedule = moment(this.item.scheluded_to).format('YYYY-MM-DD HH:mm')
                }

                if (this.item.scheluded_to) {
                    if (schedule <= now) {
                        return true // já foi enviado
                    }
                    return false // não foi enviado
                }
                if (sented <= now) {
                    return true // já foi enviado
                }
                return false // não foi enviado
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .item
        margin-bottom 10px
        border-left 3px #fff solid
        position relative
        -webkit-box-shadow 0px 0px 10px 0px rgba(0,0,0,0.05)
        -moz-box-shadow 0px 0px 10px 0px rgba(0,0,0,0.05)
        box-shadow 0px 0px 10px 0px rgba(0,0,0,0.05)

        .origin
            background $color-gray
            padding 2px 7px
            color #ffffff
            font-size 10px
            text-transform uppercase
            &.app
                background $primary
            &.api
                background $secondary
            &.type
                background $orange
                margin-left 5px

        h3
            margin 5px 0
            color #555
            a
                margin 0
                color #555
                &:hover
                    color #000

        &.schedule
            border-left 3px $schedule solid
            color $schedule

        &.deleted
            border-left 3px $deleted solid
            color $deleted
            opacity 0.4

        .date
            font-size 12px
            span
                padding-left 3px

        .group-buttons
            text-align right
            .mu-button
                margin-right 10px

        .content-box
            padding 0 0 10px 10px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .item
            margin-bottom 20px

        .content-box
            padding 0 20px 20px 20px !important

</style>
